export function newsletter() {
	let root = document.getElementsByClassName('newsletter-block');

	if(root[0]) {
		let options = document.getElementsByClassName('block-options');
		let newsletter = document.getElementsByClassName('newsletter');
		let btnBlock = document.getElementsByClassName('btn-newsletter')[0];
		let btn = btnBlock.getElementsByClassName('wp-block-button__link');
		let btnCloseBlock = document.getElementsByClassName('btn-newsletter-close')[0];
		let btnClose = btnCloseBlock.getElementsByClassName('wp-block-button__link');

		btn[0].addEventListener('click', function() {
			for(let i = 0; i < options.length; i++)
			{
				options[i].classList.add('hide');
			}
			for(let i = 0; i < newsletter.length; i++)
			{
				newsletter[i].classList.add('show');
			}
		}, true);
		btnClose[0].addEventListener('click', function() {
			for(let i = 0; i < options.length; i++)
			{
				options[i].classList.remove('hide');
			}
			for(let i = 0; i < newsletter.length; i++)
			{
				newsletter[i].classList.remove('show');
			}
		}, true);
	}
}